<div class="voicemail-outer-container">
  <app-current-path></app-current-path>
  <div class="console-container">
    <div class="name-container">
      <span>{{ title }}</span>
      <div class="btn-grp mt-2">
        <input class="main-btn" type="submit" value="Go Back" (click)="goBack()" />
        <input class="main-btn ms-2" type="submit" value="Save Changes" (click)="saveChanges()" />
      </div>
      <!-- <input class="btn btn-default cst-btn" type="submit" value="Save Changes" (click)="saveChanges()" />
      <input class="btn btn-default cst-btn" type="submit" value="Go Back" (click)="goBack()" /> -->
    </div>
    <div class="details">
      <div class="heading">
        <span class="sub-heading">VOICEMAIL DETAILS</span>

        <hr class="solid-divider" />
      </div>
      <div class="row crud-container">
        <div class="form-group voice-mail-details-field">
          <label for="agentName">Agent</label>
          <div style="display: inline-flex">
            <input
              type="text"
              [readonly]="true"
              class="form-control"
              class="inp agent-assign"
              id="agentName"
              placeholder="-"
              [value]="voiceMailDetail?.Agent"
            /><br />
            <div class="actions" style="display: inline-flex">
              <img
                *ngIf="showAgentPicker"
                (click)="selectAgent()"
                class="ico-elipsis"
                src="{{ baseHref }}/assets/images/icon-ellipsis.png"
              />
              <img
                *ngIf="showAgentPicker && agentID != null"
                (click)="deleteAssignedAgent()"
                class="ico-delete"
                src="{{ baseHref }}/assets/images/icon-delete.svg"
              />
            </div>
          </div>
        </div>

        <div class="form-group voice-mail-details-field">
          <label for="agentName">Queue</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentName"
            placeholder="-"
            [value]="voiceMailDetail?.Queue"
          />
        </div>

        <div class="form-group voice-mail-details-field">
          <label for="agentphone">InBound Number</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentphone"
            placeholder="-"
            [value]="voiceMailDetail?.InboundPhoneNumber"
          />
        </div>

        <div class="form-group voice-mail-details-field">
          <label for="agentName">InBound Skills</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentName"
            placeholder="-"
            title="voiceMailDetail?.InboundSkills"
            [value]="voiceMailDetail?.InboundSkills"
          />
        </div>

        <div class="form-group voice-mail-details-field">
          <label for="agentName">Request Type</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentName"
            placeholder="-"
            [value]="voiceMailDetail?.RequestType"
          />
        </div>
      </div>
    </div>

    <div class="details">
      <div class="heading">
        <span class="sub-heading">USER DETAILS</span>

        <hr class="solid-divider" />
      </div>
      <div class="row crud-container">
        <div class="form-group voice-mail-details-field">
          <label for="agentName">Name</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentName"
            placeholder="-"
            [value]="voiceMailDetail?.User"
          />
        </div>

        <div class="form-group voice-mail-details-field">
          <label for="agentName">Company</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentName"
            placeholder="-"
            [value]="voiceMailDetail?.Company"
          />
        </div>

        <div class="form-group voice-mail-details-field">
          <label for="agentName">Phone</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentName"
            placeholder="-"
            [value]="voiceMailDetail?.UserPhoneNumber"
          />
        </div>
      </div>
    </div>

    <div class="details">
      <div class="heading">
        <span class="sub-heading">RELATED INTERACTIONS</span>

        <hr class="solid-divider" />
      </div>
      <div class="row crud-container">
        <p-table
          [columns]="cols"
          [value]="interactions"
          [scrollable]="true"
          [style]="{ width: '100%' }"
          [scrollHeight]="'50vh'"
          [tableStyle]="{ 'min-width': '50rem' }"
          styleClass="p-datatable-sm"
          selectionMode="single"
          (onRowSelect)="onRowSelect($event)"
        >
          <ng-template pTemplate="header" let-columns>
            <tr>
              <ng-container *ngFor="let col of cols">
                <th>
                  {{ col.label }}
                  <span class="fts">
                    <span class="sort" (click)="sortByColumn(col.name)">
                      <ng-container *ngIf="col.hasOwnProperty('isAsc'); else others">
                        <ng-container *ngIf="col.isAsc; else falseBlock">
                          <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-up.png" />
                        </ng-container>
                        <ng-template #falseBlock>
                          <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-down.png" />
                        </ng-template>
                      </ng-container>

                      <ng-template #others>
                        <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort.png" />
                      </ng-template>
                    </span>
                  </span>
                </th>
              </ng-container>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr [pSelectableRow]="rowData">
              <ng-container *ngFor="let col of cols">
                <td>
                  {{ col.type && col.type === 'date' ? (rowData[col.label] | custdate) : rowData[col.label] }}
                </td>
              </ng-container>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td>No data available in table</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <div class="details">
      <div class="heading">
        <span class="sub-heading">AUDIO RECORDING</span>
    
        <hr class="solid-divider" />
      </div>
    
      <div class="row crud-container">
    
        <div class="voicemail-content">
    
          <!-- Audio -->
          <div class="voicemail-audio-section">
            <div class="section-title">Audio</div>
    
            <div class="audio-container">
              <div class="row">
                <div class="record" *ngIf="isRecordLoaded">
                  <app-videojs-wavesurfer
                    [recordingDetails]="recordingDetails">
                  </app-videojs-wavesurfer>
                </div>
              </div>
            </div>
          </div>
    
    
          <!-- Transcript -->
          <div class="voicemail-transcript-section">
            <div class="section-title">Transcript</div>
    
            <div class="transcript-container">
    
              <div class="transcript-speaker">
                {{ transcriptSpeaker }}
              </div>
    
              <div class="transcript-text">
                {{ transcriptText }}
              </div>
    
            </div>
          </div>
    
        </div>
    
      </div>
    </div>
    <!-- <div class="details">
      <div class="heading">
        <span class="sub-heading">AUDIO RECORDING</span>

        <hr class="solid-divider" />
      </div>
      <div class="row crud-container"> -->
        <!-- <app-audio [playerDetails]="playerDetails"></app-audio> -->
        <!-- <div class="audio-container">
          <div class="row">
            <div class="record" *ngIf="isRecordLoaded">
              <app-videojs-wavesurfer [recordingDetails]="recordingDetails"></app-videojs-wavesurfer>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="details">
      <div class="heading">
        <span class="sub-heading">WORKFLOW</span>

        <hr class="solid-divider" />
      </div>
      <div class="row crud-container">
        <div class="form-group voice-mail-details-field">
          <label for="agentName">Status</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentName"
            placeholder="-"
            [value]="voiceMailDetail?.Status"
          />
        </div>

        <div class="form-group voice-mail-details-field">
          <label for="agentName">Created</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentName"
            placeholder="-"
            [value]="voiceMailDetail?.Created"
          />
        </div>

        <div class="form-group voice-mail-details-field">
          <label for="agentName">Reviewed</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentName"
            placeholder="-"
            [value]="voiceMailDetail?.Reviewed"
          />
        </div>

        <div class="form-group voice-mail-details-field">
          <label for="agentName">Reponded</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentName"
            placeholder="-"
            [value]="voiceMailDetail?.Responded"
          />
        </div>

        <div class="form-group voice-mail-details-field">
          <label for="agentName">Deleted</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentName"
            placeholder="-"
            [value]="voiceMailDetail?.Deleted"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<!-- select agent popup -->
<!-- [breakpoints]="{ '60rem': '75vw' }"
[style]="{ 'max-height': '5rem' }" -->
<!-- <p-dialog
  id="dialog"
  header="Select Agent"
  [(visible)]="showSelectAgent"
  [position]="position"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="select-agent-dlg"
  #dialog
>
  <app-search-dialog
    *ngIf="showSelectAgent"
    searchType="agent"
    [agentID]="agentID"
    [isSearchTriggered]="false"
    (selectedSearchedItem)="updateSelectedAgent($event)"
  ></app-search-dialog>
</p-dialog> -->
